/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { propertyDocumentSchema } from "./propertyDocumentSchema.ts";
import { propertyMainSchema } from "./propertyMainSchema.ts";
import { propertyNegotiationTypeSchema } from "./propertyNegotiationTypeSchema.ts";
import { propertyRentDisplaySchema } from "./propertyRentDisplaySchema.ts";
import { propertySubTypeCodeSchema } from "./propertySubTypeCodeSchema.ts";
import { propertyTypeCodeSchema } from "./propertyTypeCodeSchema.ts";
import { z } from "zod";

export const propertyListSchema = z.lazy(() => propertyMainSchema).and(z.object({
      "price": z.number().describe("Prix du bien BRUT (location : loyer mensuel charges comprises)").optional(),
  "netPrice": z.number().describe("Prix du bien NET (location : loyer hors charges)").optional(),
  "charges": z.number().describe("Charges mensuelles (location)").optional(),
  "negotiationFees": z.number().describe("Frais de négociation").optional(),
  "negotiationFeesType": z.lazy(() => propertyNegotiationTypeSchema).describe("Type de négociation :\n- BUYER : Acquéreur\n- SELLER : Vendeur\n").optional(),
  "monthlyAnnuity": z.number().describe("Rente mensuelle (viager ; price porte alors le bouquet et netPrice la valeur vénale)").optional(),
  "rentDisplay": z.lazy(() => propertyRentDisplaySchema).describe("Affichage du loyer d'une location :\n- CHARGES_INCLUDED : charges comprises (CC)\n- CHARGES_EXCLUDED : hors charges (HC)\n").optional(),
  "miniature": z.lazy(() => propertyDocumentSchema).optional(),
  "numbreOfPhotos": z.number().describe("Nombre de photos").optional(),
  "landArea": z.number().describe("Surface du terrain").optional(),
  "habitableArea": z.number().describe("Surface habitable").optional(),
  "rooms": z.number().describe("Nombre de pièces").optional(),
  "bedrooms": z.number().describe("Nombre de chambres").optional(),
  "bathrooms": z.number().describe("Nombre de salles de bain").optional(),
  "propertyType": z.lazy(() => propertyTypeCodeSchema).describe("Nature du bien — valeurs et libellés dans form-rules/property-form.json (champ propertyType)").optional(),
  "propertySubType": z.lazy(() => propertySubTypeCodeSchema).describe("Sous-nature du bien — compatibilité avec la nature et libellés dans form-rules/property-form.json (champ propertySubType)").optional()
      }))